module.exports = __webpack_public_path__ + "img/hei@2x.279b3537.png";